import { createAction, props } from '@ngrx/store';

import BetslipActions from '../../base/store/actions';

export class OddsPreferencePopupActions {
    private static readonly schema = 'ODDS_PREFERENCE';
    private static readonly INCREMENT_COUNTER = `${BetslipActions.ACTION_SCHEMA}/${OddsPreferencePopupActions.schema}/INCREMENT_FAILED_BETS_COUNT`;
    private static readonly SET_DISABLED = `${BetslipActions.ACTION_SCHEMA}/${OddsPreferencePopupActions.schema}/SET_DISABLED`;
    private static readonly INITIALIZE_STATE = `${BetslipActions.ACTION_SCHEMA}/${OddsPreferencePopupActions.schema}/INITIALIZE_STATE`;
    private static readonly ACCEPT_ODDS_CHANGE = `${BetslipActions.ACTION_SCHEMA}/${OddsPreferencePopupActions.schema}/ACCEPT_ODDS_CHANGE`;

    static incrementCounter = createAction(OddsPreferencePopupActions.INCREMENT_COUNTER);
    static setDisabled = createAction(OddsPreferencePopupActions.SET_DISABLED, props<{ disabled: boolean }>());
    static initializeState = createAction(OddsPreferencePopupActions.INITIALIZE_STATE, props<{ disabled: boolean }>());
    static acceptOddsChange = createAction(OddsPreferencePopupActions.ACCEPT_ODDS_CHANGE, props<{ enable: boolean }>());
}
